export default function (isDirty: Ref<boolean>, onClose: () => void) {
  const showUnsavedChangesModal = ref(false)

  // Browser guard: inform user about unsaved changes when trying to close or reload the tab
  useEventListener('beforeunload', (event) => {
    if (isDirty.value) {
      event.preventDefault()
    }
  })

  const attemptClose = () => {
    if (isDirty.value) {
      showUnsavedChangesModal.value = true
    } else {
      onClose()
    }
  }

  const forceClose = () => {
    showUnsavedChangesModal.value = false
    onClose()
  }

  const cancelDiscard = () => {
    showUnsavedChangesModal.value = false
  }

  return {
    showUnsavedChangesModal,
    attemptClose,
    forceClose,
    cancelDiscard,
  }
}
